// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `filters-bar {
  height: calc(68px + var(--safe-area-top));
}
filters-bar .filters-bar-top {
  position: fixed;
  z-index: 3;
  width: 100%;
  top: 0;
  left: 0;
  box-sizing: border-box;
  min-height: 110px;
  padding-top: var(--safe-area-top);
  overflow: hidden;
  background: linear-gradient(rgba(31, 31, 31, 0.88), rgba(31, 31, 31, 0.7), transparent);
  pointer-events: none;
}
filters-bar .filters-bar-top .logo-container {
  flex-grow: 1;
  display: flex;
}
filters-bar .filters-bar-top .logo-container .logo {
  height: 20px;
  width: auto;
  min-width: 130px;
}
filters-bar .filters-bar-top .view-options {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0px var(--safe-area-right) 0px var(--safe-area-left);
  margin-top: 8px;
}
filters-bar .filters-bar-top .view-options button, filters-bar .filters-bar-top .view-options .profile, filters-bar .filters-bar-top .view-options .search-bar {
  pointer-events: initial;
}
filters-bar .filters-bar-top .view-options .toggle-container {
  position: relative;
  padding-right: var(--motes-padding);
}
filters-bar .filters-bar-top .view-options .toggle-container button svg-icon {
  padding-right: 0;
}
filters-bar .filters-bar-top .view-options .toggle-container .notification {
  position: absolute;
  right: 4px;
  top: 4px;
  height: 25px;
  width: 25px;
  color: var(--motes-white);
  background-color: var(--tertiary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: bold;
}
filters-bar .filters-bar-top .view-options .view-toggle {
  min-width: 120px;
  margin-left: auto;
}
filters-bar .filters-bar-top .view-options .motes-input {
  font-family: var(--header-font);
  text-overflow: ellipsis;
  padding-right: 30px;
}
filters-bar .filters-bar-top .drop-down-menu .drawer-content h4 {
  margin-left: var(--safe-area-left);
  margin-bottom: 5px;
}
filters-bar .filters-bar-top .drop-down-menu .drawer-content .options {
  display: flex;
  overflow-x: scroll;
  scrollbar-width: none;
  white-space: nowrap;
}
filters-bar .filters-bar-top .drop-down-menu .drawer-content .options > * {
  margin-right: var(--motes-padding);
}
filters-bar .filters-bar-top .drop-down-menu .drawer-content .options > *:first-child {
  margin-left: var(--safe-area-left);
}
filters-bar .filters-bar-top .drop-down-menu .drawer-content .options > *:last-child {
  margin-right: var(--safe-area-right);
}
filters-bar .filters-bar-top .drop-down-menu .drawer-content .options > * button {
  text-transform: initial;
}
filters-bar .filters-bar-top .drop-down-menu .drawer-content .options::-webkit-scrollbar {
  display: none;
}
filters-bar .filters-bar-top .profile-container {
  display: flex;
  flex: 0;
  align-items: center;
  justify-content: flex-end;
  margin-left: var(--motes-padding);
}
filters-bar .filters-bar-top .profile-container .profile {
  height: 44px;
  width: 44px;
  border-radius: 50%;
  color: var(--motes-white);
  border: 2px var(--motes-white) solid;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  box-sizing: border-box;
}
filters-bar .filters-bar-top .profile-container .profile.hide {
  opacity: 0;
}
filters-bar .filters-bar-top .profile-container .profile.golden {
  color: var(--primary-color);
  border-color: var(--primary-color);
}
filters-bar .filters-bar-top .profile-container .profile:hover, filters-bar .filters-bar-top .profile-container .profile:active {
  background-color: rgba(247, 197, 82, 0.15);
}
filters-bar .filters-bar-top .profile-container .profile picture, filters-bar .filters-bar-top .profile-container .profile img {
  height: 100%;
  width: 100%;
}
filters-bar .filters-bar-top .profile-container .profile .svg-icon {
  display: flex;
  font-size: var(--large-spacing);
}
filters-bar .my-tours {
  margin-top: 0;
  margin-bottom: 0;
  padding: 4px;
  min-height: 38px;
  font-size: 14px;
}
filters-bar .filters-bar-bottom {
  position: fixed;
  z-index: 2;
  bottom: -1px;
  left: 0;
  width: 100%;
  padding: var(--large-spacing);
  box-sizing: border-box;
  background: linear-gradient(to top, rgba(31, 31, 31, 0.8), rgba(31, 31, 31, 0.5), transparent);
  pointer-events: none;
  display: none;
}
filters-bar .filters-bar-bottom .view-toggle {
  margin: auto;
  pointer-events: initial;
}
@media only screen and (max-width: 600px) {
  filters-bar .filters-bar-top .view-options .view-toggle {
    display: none;
  }
  filters-bar .filters-bar-top .view-options .search-bar {
    width: 100%;
  }
  filters-bar .toggle-container button {
    min-width: 56px;
  }
  filters-bar .toggle-container button .svg-text {
    display: none;
  }
  filters-bar .filters-bar-bottom {
    display: initial;
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/filters-bar/filters-bar.component.scss"],"names":[],"mappings":"AAAA;EACI,yCAAA;AACJ;AACI;EACI,eAAA;EACA,UAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,iBAAA;EACA,iCAAA;EACA,gBAAA;EACA,uFAAA;EACA,oBAAA;AACR;AACQ;EACI,YAAA;EACA,aAAA;AACZ;AACY;EACI,YAAA;EACA,WAAA;EACA,gBAAA;AAChB;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,6DAAA;EACA,eAAA;AADZ;AAGY;EACI,uBAAA;AADhB;AAIY;EACI,kBAAA;EACA,mCAAA;AAFhB;AAIgB;EACI,gBAAA;AAFpB;AAKgB;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AAHpB;AAOY;EACI,gBAAA;EACA,iBAAA;AALhB;AAQY;EACI,+BAAA;EACA,uBAAA;EACA,mBAAA;AANhB;AAcgB;EACI,kCAAA;EACA,kBAAA;AAZpB;AAegB;EACI,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AAbpB;AAeoB;EACI,kCAAA;AAbxB;AAewB;EACI,kCAAA;AAb5B;AAgBwB;EACI,oCAAA;AAd5B;AAiBwB;EACI,uBAAA;AAf5B;AAmBoB;EACI,aAAA;AAjBxB;AAuBQ;EACI,aAAA;EACA,OAAA;EACA,mBAAA;EACA,yBAAA;EACA,iCAAA;AArBZ;AAuBY;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,sBAAA;AArBhB;AAuBgB;EACI,UAAA;AArBpB;AAwBgB;EACI,2BAAA;EACA,kCAAA;AAtBpB;AAyBgB;EACI,0CAAA;AAvBpB;AA0BgB;EACI,YAAA;EACA,WAAA;AAxBpB;AA2BgB;EACI,aAAA;EACA,+BAAA;AAzBpB;AA+BI;EACI,aAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AA7BR;AAgCI;EACI,eAAA;EACA,UAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,6BAAA;EACA,sBAAA;EACA,8FAAA;EACA,oBAAA;EACA,aAAA;AA9BR;AAgCQ;EACI,YAAA;EACA,uBAAA;AA9BZ;AAmCI;EAIY;IACI,aAAA;EApClB;EAsCc;IACI,WAAA;EApClB;EAyCM;IACI,eAAA;EAvCV;EAyCU;IACI,aAAA;EAvCd;EA2CM;IACI,gBAAA;EAzCV;AACF","sourcesContent":["filters-bar {\n    height: calc(68px + var(--safe-area-top));\n\n    .filters-bar-top {\n        position: fixed;\n        z-index: 3;\n        width: 100%;\n        top: 0;\n        left: 0;\n        box-sizing: border-box;\n        min-height: 110px;\n        padding-top: var(--safe-area-top);\n        overflow: hidden;\n        background: linear-gradient(rgba(31, 31, 31, 0.88), rgba(31, 31, 31, 0.7), transparent);\n        pointer-events: none;\n        \n        .logo-container {\n            flex-grow: 1;\n            display: flex;\n\n            .logo {\n                height: 20px;\n                width: auto;\n                min-width: 130px;\n            }\n        }\n\n        .view-options {\n            display: flex;\n            align-items: center;\n            box-sizing: border-box;\n            padding: 0px var(--safe-area-right) 0px var(--safe-area-left);\n            margin-top: 8px;\n\n            button, .profile, .search-bar {\n                pointer-events: initial;\n            }\n\n            .toggle-container {\n                position: relative;\n                padding-right: var(--motes-padding);\n\n                button svg-icon {\n                    padding-right: 0;\n                }\n\n                .notification {\n                    position: absolute;\n                    right: 4px;\n                    top: 4px;\n                    height: 25px;\n                    width: 25px;\n                    color: var(--motes-white);\n                    background-color: var(--tertiary-color);\n                    border-radius: 50%;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    font-size: 13px;\n                    font-weight: bold;\n                }\n            }\n                        \n            .view-toggle {\n                min-width: 120px;\n                margin-left: auto;\n            }\n\n            .motes-input {\n                font-family: var(--header-font);\n                text-overflow: ellipsis;\n                padding-right: 30px;\n            }\n        }\n\n        .drop-down-menu {\n    \n            .drawer-content {\n\n                h4 {\n                    margin-left: var(--safe-area-left);\n                    margin-bottom: 5px;\n                }\n                \n                .options {\n                    display: flex;\n                    overflow-x: scroll;\n                    scrollbar-width: none; // Hide scrollbar in firefox\n                    white-space: nowrap;\n        \n                    > * {\n                        margin-right: var(--motes-padding);\n                    \n                        &:first-child {\n                            margin-left: var(--safe-area-left);\n                        }\n        \n                        &:last-child {\n                            margin-right: var(--safe-area-right);\n                        }\n    \n                        button {\n                            text-transform: initial;\n                        }\n                    }\n        \n                    &::-webkit-scrollbar {\n                        display: none;\n                    }\n                }\n            }\n        }\n\n        .profile-container {\n            display: flex;\n            flex: 0;\n            align-items: center;\n            justify-content: flex-end;\n            margin-left: var(--motes-padding);\n\n            .profile {\n                height: 44px;\n                width: 44px;\n                border-radius: 50%;\n                color: var(--motes-white);\n                border: 2px var(--motes-white) solid;\n                overflow: hidden;\n                cursor: pointer;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                transition: 0.2s;\n                box-sizing: border-box;\n\n                &.hide {\n                    opacity: 0;\n                }\n\n                &.golden {\n                    color: var(--primary-color);\n                    border-color: var(--primary-color);\n                }\n\n                &:hover, &:active {\n                    background-color: rgba(247, 197, 82, 0.15);\n                }\n\n                picture, img {\n                    height: 100%;\n                    width: 100%;\n                }\n\n                .svg-icon {\n                    display: flex;\n                    font-size: var(--large-spacing);\n                }\n            }\n        }\n    }\n    \n    .my-tours {\n        margin-top: 0;\n        margin-bottom: 0;\n        padding: 4px;\n        min-height: 38px;\n        font-size: 14px;\n    }\n\n    .filters-bar-bottom {\n        position: fixed;\n        z-index: 2;\n        bottom: -1px;\n        left: 0;\n        width: 100%;\n        padding: var(--large-spacing);\n        box-sizing: border-box;\n        background: linear-gradient(to top, rgba(31,31,31,0.8), rgba(31,31,31,0.5), transparent);\n        pointer-events: none;\n        display: none;\n    \n        .view-toggle {\n            margin: auto;\n            pointer-events: initial;\n        }\n    }\n    \n    // Mobile view\n    @media only screen and (max-width: 600px) {\n    \n        .filters-bar-top {\n            .view-options {\n                .view-toggle {\n                    display: none;\n                }\n                .search-bar {\n                    width: 100%;\n                }\n            }\n        }\n\n        .toggle-container button {\n            min-width: 56px;\n\n            .svg-text {\n                display: none;\n            }\n        }\n    \n        .filters-bar-bottom {\n            display: initial;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
